import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { pressRelease } from "../../../services/api/PressRelease";
import PageHeader from "../../Header";
/* ================= INTERFACE ================= */
interface PressDetail {
  title: string;
  subtitle: string;
  content: string;
  featured_image: string;
  created_at: string;
  seo_title: string;
  seo_description: string;
  author: {
    id: number;
    name: string;
    email: string;
  };
}

/* ================= COMPONENT ================= */
const PressReleaseDetailPage: React.FC = () => {
  const { slug } = useParams();
  const [press, setPress] = useState<PressDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const headerTitle = slug
    ? slug
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : "News & Updates";

  useEffect(() => {
    const fetchPressDetail = async () => {
      if (!slug) {
        setLoading(false);
        return;
      }

      try {
        const response = await pressRelease(`press-releases/${slug}`); // ✅ correct template string
        setPress(response?.data?.data || null);
      } catch (err) {
        console.error("Error fetching news:", err);
        setError("Failed to load news.");
      } finally {
        setLoading(false);
      }
    };

    fetchPressDetail();
  }, [slug]);

  if (loading) {
    return <p className="text-center mt-10">Loading...</p>;
  }

  if (!press) {
    return <p className="text-center mt-10">Press release not found</p>;
  }

  return (
    <div className="min-h-screen bg-gray-50 m-2">
      {/* HEADER */}
      <PageHeader
        title="News"
        paragraph={headerTitle}
        backgroundImage=""
        align="center"
      />
      <div className="max-w-6xl mx-auto p-4 sm:p-6">
        <h1 className="text-3xl font-bold mt-6 mb-4">{press.title}</h1>
        <img
          src={press.featured_image}
          alt={press.title}
          className="w-full h-80 object-contain rounded-lg"
        />

        <p className="text-lg text-gray-600 mt-2 mb-0">{press.subtitle}</p>

        <div className="flex items-center gap-2 text-sm text-gray-500">
          <span>By</span>
          <span className="font-semibold text-gray-700">
            {press.author?.name}
          </span>
          <span>•</span>
          <span>{new Date(press.created_at).toDateString()}</span>
        </div>

        <div
          className="prose max-w-none mt-6"
          dangerouslySetInnerHTML={{ __html: press.content }}
        />
      </div>
    </div>
  );
};

export default PressReleaseDetailPage;
